import { render, staticRenderFns } from "./ss.vue?vue&type=template&id=36f90e11&"
import script from "./ss.vue?vue&type=script&lang=js&"
export * from "./ss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports